<template>
    <div class="row justify-content-center align-items-center vh-100 w-100 m-0">
        <div class="col-12 row justify-content-center align-items-center p-0">
            <div class="col-12 col-md-10 col-lg-8 col-xxl-6 p-5 form-box">
                <h2 class="text-center">M&M Security Gatehouse</h2>
                <h3 class="text-center">Změna hesla</h3>

                <div v-if="password1 != password2" class="alert alert-danger mt-3 mb-1" role="alert">
                    Hesla se neshodují
                </div>
                <label for="username" class="my-2">Nové heslo</label>
                <input type="password" id="username" class="form-control" ref="username" v-model="password1"
                    :placeholder="'Heslo'" @keyup.enter="reset()">
                <label for="password" class="my-2">Zadejte nové heslo znovu:</label>
                <input type="password" id="password1" class="form-control" ref="password" v-model="password2"
                    :placeholder="'Heslo'" @keyup.enter="reset()">
                <button type="submit" class="mt-4 p-2 btn btn_submit w-100" @click="resetPassword" :disabled="password1 != password2 || !password1">
                    Změnit heslo
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password1: null,
            password2: null,
        }
    },
    methods: {
        resetPassword() {
            this.$store.getters.api.post("/auth/reset/" + this.$route.params.slug,
                { "password": this.password1 }
            ).then((res) => {
                const data = res.data;
                if (!data || !data.gatehouses || data.gatehouses.length === 0) {
                    this.$router.push({ name: "login" });
                } else {
                    const firstGatehouse = data.gatehouses[0].slug;
                    this.$store.commit("saveUserProfile", data);
                    this.$router.push({
                        name: "dashboard",
                        params: {
                            slug: firstGatehouse
                        }
                    });
                }
            })
            .catch(() => {
                alert("Nastala chyba, odkaz je neplatný nebo vypršel.");
            });
        }
    }
}
</script>